import cx from 'classnames';
import { useFormikContext } from 'formik';
import { isEmpty } from 'lodash';
import get from 'lodash/get';
import React, { useCallback } from 'react';
import bt from '../bootstrap.module.css';
import { getDependantTriggers } from '../functions/dependants';
import icons from '../icons';
import Badge from './Badge';
import DragHandle from './component-drag-handle.jsx';

const getElementDisplayName = item => {
  if (!item) return 'Unknown component';

  const typeLabel = item.name || item.element || item.type || 'Component';
  const contentLabel = item.label || item.text;

  return contentLabel ? `${typeLabel}: ${contentLabel}` : typeLabel;
};

const HeaderBar = props => {
  const { isLastElement, data, isBuilder, registers, onSwapElements, onToggleEditing } = props;
  const { errors, values } = useFormikContext();

  const index = values.data.findIndex(({ id }) => id === data.id);
  const isErrorItem = !isEmpty(get(errors, ['data', index], null));
  const { compliance, registerId, parentId } = data;
  const isProvider = !!data?.dependantsIds?.length;
  const isDependant = !!data?.providerId;
  const provider = values.data.find(({ id }) => id === data.providerId);
  const dependantTriggerLabels = provider
    ? (provider.options || [])
        .filter(option => getDependantTriggers(provider, data.id).includes(option.id))
        .map(option => option.label || option.id)
    : [];

  const hasRequiredLabel = isBuilder && data.required && !props.read_only;

  const registerBadge =
    isBuilder &&
    compliance &&
    (registerId ? (
      <Badge type="info">
        Label: {registers.find(({ id }) => +id === +registerId)?.name || 'Deleted label'}
      </Badge>
    ) : (
      <Badge type="critical" prefix={<img alt="alert" width={16} src={icons.AlertGray} />}>
        Label: Label not selected
      </Badge>
    ));

  const handleMoveTop = useCallback(() => {
    onSwapElements(index, index - 1);
  }, [index, onSwapElements]);

  const handleMoveBottom = useCallback(() => {
    onSwapElements(index, index + 1);
  }, [index, onSwapElements]);
  return (
    <div className="toolbar-header flex flex-wrap gap-3 items-center print:hidden">
      {isErrorItem && <Badge type="critical">Invalid</Badge>}
      {isDependant && (
        <Badge type="warning">
          Dependant
          {provider ? `: ${getElementDisplayName(provider)}` : ''}
          {dependantTriggerLabels.length ? ` | ${dependantTriggerLabels.join(', ')}` : ''}
        </Badge>
      )}
      {isProvider && <Badge type="success">Provider</Badge>}
      <span className={cx('text-[16px]', 'title')}>{data?.name}</span>
      {hasRequiredLabel && <Badge type="warning">Required</Badge>}
      {registerBadge}
      <div className="toolbar-header-buttons" style={{ top: 12, right: 12, margin: 0, zIndex: 2 }}>
        {!isLastElement && !parentId && (
          <div className={cx(bt.btn, 'is-isolated')} onClick={handleMoveBottom}>
            <img alt="delete" src={icons.Arrow} />
          </div>
        )}
        {!!index && !parentId && (
          <div
            className={cx(bt.btn, 'is-isolated')}
            style={{ transform: 'rotate(180deg)' }}
            onClick={handleMoveTop}
          >
            <img alt="delete" src={icons.Arrow} />
          </div>
        )}

        {data?.canBeRedacted && (
          <div className={cx(bt.btn, 'is-isolated')} onClick={e => onToggleEditing(e, data)}>
            <img alt="edit" src={icons.Edit} />
          </div>
        )}
        <div
          className={cx(bt.btn, 'is-isolated')}
          onClick={props.onDestroy?.bind(null, props.data)}
        >
          <img alt="delete" src={icons.Trash} />
        </div>
        <DragHandle
          data={data}
          index={props.index}
          onDestroy={props.onDestroy}
          setAsChild={props.setAsChild}
        />
      </div>
    </div>
  );
};

export default HeaderBar;
